export var filterOutrightsMarkets = function (outrights, markets, events) {
    return markets.filter(function (market) {
        return outrights
            ? !!events.find(function (ev) { return ev.id === market.id; })
            : !events.find(function (ev) { return (ev.id === market.id); });
    });
};
//# sourceMappingURL=filterOutrightsMarkets.js.map